jQuery(function ($) {
  setTimeout(function () {
    jQuery(".new_home_banner").addClass("svg_animation");
  }, 100);
  banner_slider();
  home_banner_slider();
  left_offset();
  projects_delivered();
  technology_stack();
  view_popup();

  if (window.matchMedia("(max-width: 767px)").matches) {
    srervices_mobile_accordion();
  } else {
    model_tab_service();
  }
  upcoming_event();
});

function banner_slider() {
  jQuery(".template-homepage .success-slider").owlCarousel({
    items: 2,
    loop: false,
    margin: 40,
    nav: false,
    dots: false,
    autoplay: false,
    smartSpeed: 2200,
    autoplayTimeout: 3200,
    autoplayHoverPause: true,
    responsive: {
      768: {
        items: 4,
        margin: 40,
        nav: true,
      },
      1024: {
        items: 5,
        loop: true,
        autoplay: true,
        margin: 60,
      },
      1200: {
        items: 6,
        nav: false,
        autoplay: false,
      },
      1340: {
        items: 6,
        autoplay: false,
        loop: true,
      },
    },
  });
}

function left_offset() {
  if (window.innerWidth > 767) {
    var x = jQuery(".site-header").offset();
    // console.log(x);
    jQuery(".our_services_tabs #tabs-nav").css("padding-left", x.left);
    jQuery(".tab-content-inner").css("padding-right", x.left);
  }
}

function model_tab_service() {
  jQuery(".our_services #tabs-nav li:first-child").addClass("active");
  jQuery(".our_services .tab-content").hide().removeClass("bg_change");
  jQuery(".our_services .tab-content:first").show().addClass("bg_change");

  jQuery(".our_services #tabs-nav li").click(function () {
    jQuery(".our_services #tabs-nav li").removeClass("active");
    jQuery(this).addClass("active");
    jQuery(".our_services .tab-content").hide().removeClass("bg_change");

    var activeTab = jQuery(this).find("a").attr("href");
    jQuery(activeTab).fadeIn(800).addClass("bg_change");
    return false;
  });
}

function srervices_mobile_accordion() {
  jQuery(".our_services-acc-container .our_services-acc:first-child").addClass(
    "open"
  );
  jQuery(
    ".our_services-acc-container .our_services-acc:nth-child(1) .our_services-acc-head"
  ).addClass("active");
  jQuery(
    ".our_services-acc-container .our_services-acc:nth-child(1) .our_services-acc-content"
  ).slideDown();
  jQuery(".our_services-acc").on("click", function () {
    jQuery(this).addClass("open");
    if (jQuery(this).hasClass("open")) {
      jQuery(this).children(".our_services-acc-content").slideToggle();
      jQuery(this).children(".our_services-acc-head").toggleClass("active");
    }

    jQuery(".open").not(this).children(".our_services-acc-content").slideUp();
    jQuery(".open")
      .not(this)
      .children(".our_services-acc-head")
      .removeClass("active");
  });
}

function projects_delivered() {
  jQuery(".projects_delivered_slider").owlCarousel({
    center: true,
    items: 1,
    loop: false,
    dots: true,
    smartSpeed: 2200,
    paginationSpeed: 2000,
    autoplayTimeout: 7500,
    autoplay: false,
    autoplayHoverPause: true,
    responsive: {
      768: {
        items: 2,
        loop: true,
      },
      1024: {
        loop: true,
        autoplay: true,
        items: 2,
      },
      1200: {
        items: 3,
        loop: true,
        autoplay: true,
      },
    },
  });
}

// Technology Stack section js start here
function technology_stack() {
  jQuery(".technology_stack_tabs li:first-child").addClass("current");
  jQuery(".technology_tab-content:first").addClass("current");
  jQuery(".technology_stack_tabs li").click(function () {
    var tab_id = $(this).attr("data-tab");
    jQuery(".technology_stack_tabs li").removeClass("current");
    jQuery(".technology_tab-content").removeClass("current");
    jQuery(this).addClass("current");
    jQuery("#" + tab_id).addClass("current");
  });
}

function view_popup() {
  jQuery(document).on("click", "a.video-popup", function () {
    var youtube_url = jQuery(this).attr("href");
    if (youtube_url) {
      jQuery.fancybox({
        type: "iframe",
        wrapCSS: "youtube-video",
        href: youtube_url,
        onComplete: function () {
          jQuery("#fancybox-frame").attr("allowfullscreen", "allowfullscreen");
        },
        beforeShow: function () {
          if (jQuery(".video-testimonials").length) {
            jQuery(".video-testimonials")
              .owlCarousel()
              .trigger("stop.owl.autoplay");
          }
        },
        afterClose: function () {
          if (jQuery(".video-testimonials").length) {
            jQuery(".video-testimonials")
              .owlCarousel()
              .trigger("play.owl.autoplay", [5000]);
          }
        },
      });
      return false;
    } else {
      return false;
    }
  });
}

//indian achiver home banner js
function home_banner_slider() {
  jQuery(".home_banner_slider").owlCarousel({
    // autoplay: true,
    dots: true,
    // autoHeight: true,
    autoplayTimeout: 7500,
    smartSpeed: 3000,
    slideSpeed: 4000,
    items: 1,
    loop: true,
  });
}

// Meet Our Experts at Upcoming Events



// Function to set equal height
function setEqualHeight() {
  let $items = $('.event-box-slider .item');
  let maxHeight = 0;

  // Reset height to auto before recalculating
  $items.css('height', 'auto');

  // Calculate the tallest slide's height
  $items.each(function () {
    let thisHeight = $(this).outerHeight();
    if (thisHeight > maxHeight) maxHeight = thisHeight;
  });

  // Apply the tallest height to all slides
  $items.css('height', maxHeight + 'px');
}
function applyHeightConditionally() {
  if (window.innerWidth > 1200) {
    setEqualHeight();  // Apply equal height only if screen width > 1400px
  } else {
    $items.css('height', 'auto');  // Reset height for smaller screens
  }
}
function upcoming_event() {
  let slideCount = $('.event-box-slider .item').length;

  if (slideCount > 3) {
    jQuery('.event-box-slider').addClass('inactivegrid')
    jQuery('.event-box-slider').owlCarousel({
      loop: true,

      nav: true,


      dots: false,
      responsive: {
        0: { items: 1 },
        600: { items: 2 },
        1000: { items: 3 }
      },
      onInitialized: setEqualHeight,  // Call after init
      onRefreshed: setEqualHeight
    });
  }
  else {
    setEqualHeight();
  }
  $(window).on('resize', function () {
    applyHeightConditionally();
  });
}





// WEBPACK FOOTER //
// ./scripts/home/script.js